import React, { Component } from "react";
import { connect } from "react-redux";
import Helmet from "react-helmet";
import moment from "moment-timezone";

// Components
import BodyWrap from "../utils/BodyWrap";
import ContentDiv from "../utils/ContentDiv";
import GeneralLoader from "../GeneralLoader";
import ErrorText from "../utils/error-success/ErrorText";
import SectionFooter from "../utils/SectionFooter";
import SectionBanner from "../utils/SectionBanner";
import ReviewPreview from "./ReviewPreview";
import ProfileTable from "../reviewer/profile/ProfileTable";
import LocationMap from "../utils/maps/LocationMap";
import AddressMapDialog from "../utils/dialogs/AddressMapDialog";
import DocumentList from "../utils/DocumentList";

// State
import { getTranslations } from "../../store/actions/translations";
import { getReviewRecord } from "../../store/actions/reviews";

// Utils
import getFormattedAddress from "../../utils/reviews/addresses";
import { showReviewLocation } from "../../utils/reviews/reviewLocation";

class ReviewRecord extends Component {
	constructor(props) {
		super(props);
		this.state = {
			showMapDialog: false
		};
	}

	static initialAction(store, props, translationKey = null) {
		const promises = [];
		const translationSections = ["review_record", "buttons"];

		if (translationKey === null) {
			translationKey = props.translationKey;
		}

		let resTranslations =
			store !== null
				? getTranslations([translationKey], translationSections, translationKey)
				: props.getTranslations([translationKey], translationSections, translationKey);
		promises.push(resTranslations);

		return promises;
	}

	static userActions(store, props) {
		const promises = [];

		const id = props.params ? props.params.id : props.match.params.id;

		if (store !== null) {
			promises.push(getReviewRecord(id));
		} else {
			promises.push(props.getReviewRecord(id));
		}

		return promises;
	}

	componentWillMount() {
		if (!this.props.translations.pages[this.props.translationKey]) {
			ReviewRecord.initialAction(null, this.props);
		}

		ReviewRecord.userActions(null, this.props);
	}

	calculateDaysTotal = () => {
		const { reviewRecord } = this.props;

		let total = reviewRecord.reviewers.on_site.length + reviewRecord.reviewers.reading.length;
		return total;
	};

	calculateReviewerDays = () => {
		const { reviewRecord } = this.props;

		const a = moment(reviewRecord.site_visit_starts);
		const b = moment(reviewRecord.site_visit_ends);
		const total = Math.abs(a.diff(b, "days")) + 1;

		return total;
	};

	render() {
		const {
			translationsLoading,
			translations,
			reviewRecord,
			recordIsLoading,
			reviewError
		} = this.props;

		// ===================================
		//	HELMET STUFF
		// ===================================
		let helmet = null;

		let title = "";
		if (this.props.siteInfo.site) {
			title += this.props.siteInfo.site.title;
		}
		if (!!translations.pages[this.props.translationKey]) {
			if (title !== "") title += " | ";
			title += translations.pages[this.props.translationKey].title;
		}

		// helmet = (
		// 	<Helmet>
		// 		<title>{title}</title>
		// 		<meta property="og:title" content={title} />
		// 		<meta property="og:description" content={title} />
		// 		<meta property="twitter:title" content={title} />
		// 	</Helmet>
		// );

		// Formatted address
		const formattedAddress = !!reviewRecord ? getFormattedAddress(reviewRecord) : null;
		console.log(reviewRecord);
		return (
			<BodyWrap>
				{/* {helmet} */}
				<main>
					<div className="page-content">
						<div className="section-row">
							<div className="section section-2--main">
								{translationsLoading ? (
									<GeneralLoader />
								) : !!translations.pages[this.props.translationKey] ? (
									<ContentDiv>
										{translations.pages[this.props.translationKey].content}
									</ContentDiv>
								) : null}
							</div>
							{!translationsLoading && (
								<div className="section section-2--side">
									<SectionFooter href="/reviews/related">
										{translations.sections.review_record.view_my_reviews_link}
									</SectionFooter>
								</div>
							)}
						</div>
						{!translationsLoading && (
							<div className="section-row">
								{recordIsLoading ? (
									<GeneralLoader />
								) : (
										<React.Fragment>
											{!!reviewError ? (
												<ErrorText errors={reviewError} />
											) : (
													<React.Fragment>
														<div className="section section-2--side">
															<ReviewPreview
																review={reviewRecord}
																hideButtons={true}
															/>
															{reviewRecord.location !== "Virtual" && formattedAddress && (
																<div
																	className="side-map-wrapper"
																	onClick={() =>
																		this.setState({
																			showMapDialog: true
																		})
																	}
																>
																	<LocationMap
																		address={formattedAddress}
																		loadingElement={<GeneralLoader />}
																		googleMapURL="https://maps.googleapis.com/maps/api/js?v=3.exp&key=AIzaSyA2mfXsrW3E8ZKx7pxKPFBRy-qE-wAEgOg&libraries=places"
																	/>
																	<div className="map-title">
																		{
																			translations.sections
																				.review_record
																				.open_map_button
																		}
																	</div>
																</div>
															)}

															{!!reviewRecord.documents.length && (
																<DocumentList
																	documents={reviewRecord.documents}
																	title={
																		translations.sections.review_record
																			.review_documents_title
																	}
																/>
															)}
														</div>
														<div className="section section-2--main">
															<SectionBanner>
																{
																	translations.sections.review_record
																		.review_info_title
																}
															</SectionBanner>

															<div className="section-content">
																<ProfileTable
																	classes={"profile-table--no-inputs"}
																>
																	<tr>
																		<th>
																			{
																				translations.sections
																					.review_record
																					.organization
																			}
																			:
																</th>
																		<td>
																			{
																				reviewRecord.organization_title
																			}
																		</td>
																	</tr>
																	<tr>
																		<th>
																			{
																				translations.sections
																					.review_record.location
																			}
																			:
																</th>
																		<td>
																			{
																				reviewRecord.location === "Virtual" ? reviewRecord.location : showReviewLocation(reviewRecord)
																			}
																		</td>
																	</tr>
																	<tr>
																		<th>
																			{
																				translations.sections
																					.review_record
																					.status_notes
																			}
																			:
																</th>
																		<td>
																			{!!reviewRecord.status_notes && (
																				<ContentDiv>
																					{
																						reviewRecord.status_notes
																					}
																				</ContentDiv>
																			)}
																		</td>
																	</tr>
																	<tr>
																		<th>
																			{
																				translations.sections
																					.review_record
																					.cca_manager
																			}
																			:
																</th>
																		<td>
																			{
																				reviewRecord.cca_manager_specialist
																			}
																		</td>
																	</tr>
																	<tr>
																		<th>
																			{
																				translations.sections
																					.review_record
																					.main_sector
																			}
																			:
																</th>
																		<td>
																			{reviewRecord.sector_description} ({reviewRecord.main_module_title})
																		</td>
																	</tr>
																	<tr>
																		<th>
																			{
																				translations.sections
																					.review_record.modules
																			}
																			:
																</th>
																		<td>
																			{reviewRecord.other_modules.map(
																				(module, i) => (
																					<div key={i}>
																						{module.title}
																					</div>
																				)
																			)}
																		</td>
																	</tr>
																	<tr>
																		<th>
																			{
																				translations.sections
																					.review_record
																					.french_aspect
																			}
																			:
																</th>
																		<td>
																			{reviewRecord.french_aspect_required
																				? translations.sections
																					.buttons.yes
																				: translations.sections
																					.buttons.no}
																		</td>
																	</tr>
																	<tr>
																		<th>
																			{
																				translations.sections
																					.review_record
																					.site_visit_notes
																			}
																			:
																</th>
																		<td>
																			{!!reviewRecord.site_visit_notes && (
																				<ContentDiv>
																					{
																						reviewRecord.site_visit_notes
																					}
																				</ContentDiv>
																			)}
																		</td>
																	</tr>
																	<tr>
																		<th>
																			{
																				translations.sections
																					.review_record
																					.am_pm_start
																			}
																			:
																</th>
																		<td>{reviewRecord.am_pm_start}</td>
																	</tr>
																	<tr>
																		<th>
																			{
																				translations.sections
																					.review_record
																					.site_visit_starts
																			}
																			:
																</th>
																		<td>
																			{reviewRecord.site_visit_starts &&
																				moment(
																					reviewRecord.site_visit_starts
																				)
																					.local()
																					.subtract(1, 'days')																				
																					.format("DD-MMM-YY")}
																		</td>
																	</tr>
																	<tr>
																		<th>
																			{
																				translations.sections
																					.review_record
																					.site_visit_ends
																			}
																			:
																</th>
																		<td>
																			{reviewRecord.site_visit_ends &&
																				moment(
																					reviewRecord.site_visit_ends
																				)
																					.local()
																					.subtract(1, 'days')
																					.format("DD-MMM-YY")}
																		</td>
																	</tr>
																	<tr>
																		<th>
																			{
																				translations.sections
																					.review_record
																					.team_arrives_by
																			}
																			:
																</th>
																		<td>
																			{reviewRecord.team_arrives &&
																				moment(
																					reviewRecord.team_arrives
																				)
																					.local()
																					.subtract(1, 'days')
																					.format("DD-MMM-YY")}
																		</td>
																	</tr>
																	<tr>
																		<th>
																			{
																				translations.sections
																					.review_record
																					.team_departs
																			}
																			:
																</th>
																		<td>
																			{reviewRecord.team_departs &&
																				moment(
																					reviewRecord.team_departs
																				)
																					.local()
																					.subtract(1, 'days')
																					.format("DD-MMM-YY")}
																		</td>
																	</tr>
																	<tr>
																		<th>
																			{
																				translations.sections
																					.review_record
																					.on_site_reviewers
																			}
																			:
																</th>
																		<td>
																			{reviewRecord.reviewers
																				.on_site &&
																				reviewRecord.reviewers
																					.on_site.length}
																		</td>
																	</tr>
																	<tr>
																		<th>
																			{
																				translations.sections
																					.review_record
																					.reading_reviewers
																			}
																			:
																</th>
																		<td>
																			{reviewRecord.reviewers
																				.reading &&
																				reviewRecord.reviewers
																					.reading.length}
																		</td>
																	</tr>
																	<tr>
																		<th>
																			{
																				translations.sections
																					.review_record
																					.number_of_days_total
																			}
																			:
																</th>
																		<td>{this.calculateDaysTotal()}</td>
																	</tr>
																	<tr>
																		<th>
																			{
																				translations.sections
																					.review_record
																					.reviewer_days
																			}
																			:
																</th>
																		<td>
																			{this.calculateReviewerDays()}
																		</td>
																	</tr>
																	{reviewRecord.reviewers.reading.map(
																		(reviewer, i) => (
																			<tr key={i}>
																				<th>
																					{
																						translations
																							.sections
																							.review_record
																							.reading_reviewers_rr
																					}
																				</th>
																				<td>{`${reviewer.fname} ${
																					reviewer.lname
																					}`}</td>
																			</tr>
																		)
																	)}
																	{reviewRecord.reviewers.on_site.map(
																		(reviewer, i) => (
																			<tr key={i}>
																				<th>
																					{
																						translations
																							.sections
																							.review_record
																							.reviewer_label
																					}{" "}
																					({i + 1})
																		</th>
																				<td>{`${reviewer.fname} ${
																					reviewer.lname
																					}`}</td>
																			</tr>
																		)
																	)}
																</ProfileTable>
															</div>
														</div>
														<AddressMapDialog
															show={this.state.showMapDialog}
															address={formattedAddress}
															handleClose={() =>
																this.setState({ showMapDialog: false })
															}
														/>
													</React.Fragment>
												)}
										</React.Fragment>
									)}
							</div>
						)}
					</div>
				</main>
			</BodyWrap>
		);
	}
}

const mapStateToProps = (state, props) => {
	return {
		siteInfo: state.siteInfo,
		translationsLoading:
			state.translations.isLoading[props.translationKey] === undefined
				? 1
				: state.translations.isLoading[props.translationKey],
		translations: state.translations.translations,
		recordIsLoading:
			state.reviews.recordIsLoading === undefined ? true : state.reviews.recordIsLoading,
		reviewRecord: state.reviews.reviewRecord === undefined ? null : state.reviews.reviewRecord,
		reviewError: state.reviews.errorRecord === undefined ? null : state.reviews.errorRecord
	};
};

export default connect(
	mapStateToProps,
	{ getTranslations, getReviewRecord }
)(ReviewRecord);



// WEBPACK FOOTER //
// ./src/components/reviews/ReviewRecord.js